import { Window } from "@progress/kendo-react-dialogs";
import axios from "axios";
import { useEffect, useState } from "react";
import "./LearningGallery.css";

const LearningGallery = ({ onClose }) => {
  const [videos, setVideos] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const templateId = "a1c5e4e7-8da4-4f45-ab68-a30031a28339";

  const fetchVideos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/Entry/templateId/${templateId}`,
        {
          params: {
            maxItemCount: -1,
          },
        }
      );
      const videosData = response.data.map((entry) => ({
        title: entry.sections[0].fields.find((field) => field.fieldName === "Title").value,
        description: entry.sections[0].fields.find((field) => field.fieldName === "Description")
          .value,
        link: entry.sections[0].fields.find((field) => field.fieldName === "Link").value,
      }));
      setVideos(videosData);
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredVideos = videos.filter(
    (video) =>
      video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      video.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Window
      onClose={onClose}
      className="learning-gallery-window"
      initialHeight={800}
      initialWidth={1200}
      title={"Learning Gallery"}
      modal={true}
    >
      <input
        type="text"
        placeholder="Search by title or description..."
        value={searchTerm}
        onChange={handleSearchChange}
        className="search-input"
      />
      <div className="video-gallery">
        {filteredVideos.map((video, index) => (
          <div
            key={video.title + "_" + index}
            className="video-card"
          >
            <iframe
              src={video.link}
              title={video.title}
            ></iframe>
            <h3>{video.title}</h3>
            <p>{video.description}</p>
          </div>
        ))}
      </div>
    </Window>
  );
};

export default LearningGallery;
